/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { SparseMatrixDependencies } from './dependenciesSparseMatrixClass.generated';
import { absDependencies } from './dependenciesAbs.generated';
import { addDependencies } from './dependenciesAdd.generated';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated';
import { largerDependencies } from './dependenciesLarger.generated';
import { largerEqDependencies } from './dependenciesLargerEq.generated';
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { subtractDependencies } from './dependenciesSubtract.generated';
import { transposeDependencies } from './dependenciesTranspose.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSlu } from '../../factoriesAny.js';
export var sluDependencies = {
  SparseMatrixDependencies: SparseMatrixDependencies,
  absDependencies: absDependencies,
  addDependencies: addDependencies,
  divideScalarDependencies: divideScalarDependencies,
  largerDependencies: largerDependencies,
  largerEqDependencies: largerEqDependencies,
  multiplyDependencies: multiplyDependencies,
  subtractDependencies: subtractDependencies,
  transposeDependencies: transposeDependencies,
  typedDependencies: typedDependencies,
  createSlu: createSlu
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSlu.generated.js
// module id = 524
// module chunks = 0